import BaseDialog from "./BaseDialog";
import Input from "../../form_components/Input";
import Utility from "../../utilities/Utility";
import ReactDOM from "react-dom";
import BlankElementEmbed from "./BlankElementEmbed";
import { getGlobalSettings } from "../../stores";

export default class NewPromptDialog extends BaseDialog {
    /**
     * Dialog for adding a new prompt for dialog editor
     * @module NewPromptDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.state = {
            prompt: "",
            text: "",
            node: null
        };
    }

    setConfig(key, value) {
        if (key === "prompt") {
            let node;
            // match node by id
            if (value.length === 36) {
                node = window.apm.getNode(value);
            }
            // match node by name
            if (!node) {
                const objects = window.apm.serialized.components.objects;
                node = objects.find(p => (p._class === "PromptNodeModel" && p.name === value));
            }
            this.setState({
                prompt: node ? node.name : value,
                node: node
            });
        } else {
            this.setState({
                [key]: value
            });
        }
    }

    getConfig(key) {
        return this.state[key];
    }

    /**
     * Handle add to module event
     * @param event
     */
    handleAdd() {
        if (!this.state.prompt && !this.state.node) {
            window.apm.popupMessage("Prompt cannot be empty");
            return;
        }
        let node = this.state.node;
        if (node) {
            document.dispatchEvent(new CustomEvent("ev-dialog-node-add", {
                detail: {
                    node: node,
                    type: "prompt"
                }
            }));
            w2popup.close();
        } else {
            const addFunc = (treeL, serialized) => {
                window.apm.addNode(serialized);
                treeL.jstree().create_node("Prompt", Utility.getTreeNode(serialized), "last");
                document.dispatchEvent(new CustomEvent("ev-dialog-node-add", {
                    detail: {
                        node: serialized,
                        type: "prompt"
                    }
                }));
            };
            w2popup.message({
                width: 500,
                height: 600,
                html: '<div class="blank_container"></div>',
                onOpen: () => {
                    this.intervalHandler = setInterval(() => {
                        if ($(".blank_container")) {
                            clearInterval(this.intervalHandler);

                            $(".w2ui-message").css("transform", "");
                            ReactDOM.render(
                                <BlankElementEmbed key={Utility.uuid4()} addFunc={addFunc} type="prompt"
                                    nodeName={this.state.prompt} />, $(".blank_container").get(0));
                        }
                    }, 10);
                }
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.addHandle);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const lang = getGlobalSettings().language;
        const description = this.state.node ? this.state.node.props.config.text[lang] : "";
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className="col-md-12">
                            <p>Create a new prompt or search for an existing prompt.</p>
                            <Input
                                label="Prompt name"
                                value={this.state.prompt}
                                valRules={{ "objectName": true, "noEmpty": true }}
                                context={this}
                                valKey={"prompt"}
                                suggestion={"prompt"}
                            />
                            <br />
                            {description && <div>
                                <label>Prompt text</label>
                                <p>{description}</p>
                            </div>}
                            {(this.state.prompt && !this.state.node) && <div>
                                <p>The prompt you entered is not found in the application. A new prompt will be
                                    created.</p>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}